import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { strategyTranslation } from 'modules/performance_process/lib/reviewStrategy'

import { NewScoreCard } from './NewScoreCard'

type Props = {
  strategy: PerformanceReviewerStrategiesStrategyEnum
  strategies: PerformanceReviewerStrategiesStrategyEnum[]
  onAddScore: () => void
}
export const NoScoreState: React.FC<Props> = ({ strategy, strategies, onAddScore }) => {
  const strategyName = strategyTranslation(strategy)
  return (
    <Box flexDirection="column" gap="s24" alignItems="center">
      <Box padding="s24">
        <NewScoreCard currentStrategy={strategy} strategies={strategies} />
      </Box>

      <Box flexDirection="column" gap="s8" alignItems="center" textAlign="center" paddingX="s8">
        <Text.Normal weight="semibold" color="grey1000" size="400">
          {i18n.t('performance_process.score_strategy_weights.no_score_state.title', {
            strategyName: strategyName.toLowerCase(),
          })}
        </Text.Normal>
        <Text.Normal size="300" color="grey800">
          {i18n.t('performance_process.score_strategy_weights.no_score_state.description', {
            strategyName,
          })}
        </Text.Normal>
      </Box>
      <Button onClick={onAddScore}>
        {i18n.t('performance_process.score_strategy_weights.add_score')}
      </Button>
    </Box>
  )
}
